//place this in index.js file: <div id="snackbar">snacks</div>
export interface SnackBarConfig {
    text?: string; 
    type?: "primary" | "error" | "warning" | "success" | "plain" | "custom" | string;
    timeout?: number; 
    manual?: boolean
}
const defaultConfigValue: SnackBarConfig = {
    text: "",
    type: "plain",
    timeout: 3000,
    manual: false
}

const snackBar = (snackBarConfig: { text?: string, type?: string, timeout?: number }, styles?: any) => {
    const config: SnackBarConfig = {...defaultConfigValue, ...snackBarConfig};
    let snack: any = document.getElementById("snackbar");
    if(config.manual){
        snack.innerHTML = `
        <div class="d-flex justify-content-between align-items-center">
            <span class="snackbar-text">${config.text}</span>
            <i id="snackbar-close" class="material-icons action-text">close</i>
        </div>
        `;
    }else{
        snack.innerHTML = config.text;
    }
    snack.className = "show"
    snack.style.color = "#fff"
    if (config.type === "plain") {
        snack.style.backgroundColor = "#696969"
        snack.style.color = "#fff"
    }
    if (config.type === "primary") {
        snack.style.backgroundColor = "#007bff"
        snack.style.color = "#fff"
    }
    if (config.type === "error") {
        snack.style.backgroundColor = "#dc3545"
    }
    if (config.type === "warning") {
        snack.style.backgroundColor = "#ffc107"
    }
    if (config.type === "success") {
        snack.style.backgroundColor = "#28a745"
    }
    if (config.type === "custom") {
        snack.style.backgroundColor = styles.bg;
        snack.style.color = styles.color;
        snack.style.zIndex = styles.zIndex || 1;
    }

    if(config.manual){
        const closeButton: any = document.getElementById("snackbar-close");
        closeButton.addEventListener("click", () => {
            snack.className = snack.className.replace("show", "")
        });
    }else{
        setTimeout(function () {
            snack.className = snack.className.replace("show", "")
        }, config.timeout ? config.timeout : 3000);
    }
}
export default snackBar;